import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/ChatgptStatistics/index",{...params
    } )
}

function EXPORT(params) {
    return  axios.post("/statistics/ChatgptStatistics/export",{ ...params
    }  )
}

export default {
    GET_LIST,
    EXPORT,

};
